// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"water_contentContainer__2mS3l","socialIcon":"water_socialIcon__T0F1L","footerBlock":"water_footerBlock__2AZAc","footerSection":"water_footerSection__3NJcm"};